import { login, logout, getProfile, getPermissionResources } from '@/api/auth'
import { hasSession, markSession, clearSession } from '@/utils/auth'

const state = {
  /** 与 Cookie 会话同步的前端标记，不是密钥 */
  signedIn: hasSession(),
  userInfo: null,
  permission: null
}

const mutations = {
  MARK_SIGNED_IN (state) {
    state.signedIn = true
    markSession()
  },
  SET_USER_INFO (state, info) {
    state.userInfo = info
  },
  SET_PERMISSION (state, p) {
    state.permission = p
  },
  CLEAR_SESSION (state) {
    state.signedIn = false
    state.userInfo = null
    state.permission = null
    clearSession()
  }
}

const actions = {
  async login ({ commit }, { username, password }) {
    const res = await login({ username, password })
    const userInfo = res?.userInfo ?? res?.data?.userInfo ?? { username }
    commit('MARK_SIGNED_IN')
    commit('SET_USER_INFO', userInfo || { username })
    try {
      const perm = await getPermissionResources()
      commit('SET_PERMISSION', perm?.data ?? perm ?? null)
    } catch (_) {
      commit('SET_PERMISSION', null)
    }
  },
  async logout ({ commit }) {
    try {
      await logout()
    } catch (e) {
      // ignore when backend is down
    }
    commit('CLEAR_SESSION')
  },
  async fetchPermission ({ commit, state }) {
    if (!hasSession() && !state.signedIn) return
    try {
      const perm = await getPermissionResources()
      commit('SET_PERMISSION', perm?.data ?? perm ?? null)
      commit('MARK_SIGNED_IN')
      if (!state.userInfo && perm?.data) {
        const profile = await getProfile()
        const p = profile?.data ?? profile
        if (p?.username) commit('SET_USER_INFO', { ...p, canDelete: perm?.data?.canDelete ?? p?.canDelete })
      }
    } catch (_) {
      /* 401 由 request 拦截器清会话 */
    }
  }
}

const getters = {
  isLoggedIn: state => state.signedIn || hasSession(),
  userInfo: state => state.userInfo,
  permission: state => state.permission,
  canDelete: state => state.permission?.canDelete ?? state.userInfo?.canDelete ?? true,
  canAccess: state => (page, op = 'view') => {
    const p = state.permission
    if (!p) return false
    if (p.menus === null) return true
    if (p.permissionsConfig?.pageOps) {
      const ops = p.permissionsConfig.pageOps[page]
      if (ops && Array.isArray(ops) && ops.includes(op)) return true
    }
    if (!p.menus?.includes(page)) return false
    if (op === 'view') return true
    if (op === 'delete') return p.canDelete
    return true
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
